import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAerlingusComponent } from './simple-icons-aerlingus.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAerlingusComponent ],
    exports:      [ SimpleIconsAerlingusComponent ],
    bootstrap:    []
})
export class SimpleIconsAerlingusModule {}
